'use client';

const errorLabel = "Error:";
export {
  errorLabel
};
